import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { FormType } from './types/types';
import {bookingConfig} from './types/types';
import { Provider } from 'react-redux';
import store from './store'
import { dev } from './data/price';

const container = document.getElementById('root')!;
const lang = container.getAttribute('lang') ?? 'en';
let formType = (container.getAttribute('formtype') ?? 'Default') as FormType;
// Create a root.
const root = ReactDOMClient.createRoot(container);

// Set default path for backend requests
axios.defaults.baseURL = 'https://' + (document?.location?.host ?? 'www.lazertag.be') + '/wp-admin/';
if ('development' === process.env.NODE_ENV){
    // Override default path for backend requests
    axios.defaults.baseURL = 'https://www.zombiezombie.be/wp-admin/';
    // axios.defaults.baseURL = 'https://www.lazertag.be/wp-admin/';
} else if (!dev) {
    console.log = () => {};
    console.trace = () => {};
    console.table = () => {};
    console.error = () => {};
    console.debug = () => {};
}

Bugsnag.start({
    apiKey: '8a4a640914ef0562b446d63bef530249',
    maxEvents: 100,
    plugins: [new BugsnagPluginReact()]
})
const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);


fetch(axios.defaults.baseURL + "admin-ajax.php?action=new_booking_get_config2").then(response => {
    console.log("Window and config reloaded");
    response.json().then(json => {
        window.bookingConfig = json as bookingConfig;

        // Initial render: Render an element to the root.
        // @ts-ignore
        root.render(<ErrorBoundary>
            <Provider store={store}>
                <App lang={lang} formType={formType}/>
            </Provider>
        </ErrorBoundary>);
    });
});
